module.exports = __webpack_public_path__ + "img/img 3.7fc78b48.png";